import { IEvent } from '../models/events-models';
import { Event } from '../models/events-viewmodels';
import { formatDate } from '@/shared/services/format-date-filter';

/**
 * Mapper for the Events Schedule service
 */
export default class EventMapper {
    public mapEvent(item: IEvent): Event {
        return new Event(
            item.Title,
            formatDate(item.Start, 'H:mm'),
            formatDate(item.End, 'H:mm'),
            item.Locations[0] ? item.Locations[0].Description : ''
        );
    }
}
